<div [@routerTransition]="'fly'">
  <div *ngIf="readWriteFacilities">
    <div class="table-top">
      <div class="hide-xs layout padding-right-md">
        <button
          mat-icon-button
          routerLink="new"
          matTooltip="Add"
        >
          <mat-icon>add_circle</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <ifc-app-scroll-container [default]="true">
    <div
      class="message-box info"
      *ngIf="!data.dataSource.totalCount"
      fxLayout="row"
      fxLayoutGap="12px"
      fxLayoutAlign="start center"
    >
      <mat-icon class="icon">info</mat-icon>
      <span>No data found</span>
    </div>

    <table
      aria-label="Table of facilities"
      *ngIf="data.dataSource.totalCount"
      mat-table
      matSort
      [dataSource]="data.dataSource.values"
    >
      <ng-container matColumnDef="facilityName">
        <th mat-header-cell *matHeaderCellDef>Facility name</th>
        <td mat-cell *matCellDef="let row" class="table-cell">
          {{ row.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="isDefault">
        <th mat-header-cell *matHeaderCellDef>Default facility</th>
        <td mat-cell *matCellDef="let row" class="table-cell">
          {{ row.isDefault | booleanValueLabel : FacilitiesIsDefaultLabel }}
        </td>
      </ng-container>

      <ng-container matColumnDef="allowedProducts">
        <th mat-header-cell *matHeaderCellDef>Allowed products</th>
        <td mat-cell *matCellDef="let row" class="table-cell">
          <ng-container *ngFor="let productCode of row.allowedProducts; let isLast = last">
            {{ productCode | productCodeLabel }}<span *ngIf="!isLast">, </span>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="maximumAcceptableLoanCreditLimit">
        <th mat-header-cell *matHeaderCellDef>Loan limit</th>
        <td mat-cell *matCellDef="let row" class="table-cell">
          {{ row.maximumAcceptableLoanCreditLimit | currency:'$' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="borrowingCapacity">
        <th mat-header-cell *matHeaderCellDef>Borrowing capacity</th>
        <td mat-cell *matCellDef="let row" class="table-cell">
          {{ row.borrowingCapacity | currency:'$' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let row" class="table-cell">
          {{ row.active | booleanValueLabel : FacilitiesActiveLabel }}
        </td>
      </ng-container>

      <ng-container matColumnDef="outboundBankAccount">
        <th mat-header-cell *matHeaderCellDef>Operational account - Outbound</th>
        <td mat-cell *matCellDef="let row" class="table-cell">
          {{ row.outboundBankAccount.bankName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="inboundBankAccount">
        <th mat-header-cell *matHeaderCellDef>Operational account - Inbound</th>
        <td mat-cell *matCellDef="let row" class="table-cell">
          {{ row.inboundBankAccount.bankName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions" stickyEnd>
        <th mat-header-cell *matHeaderCellDef mat-sort-header="actions" style="width: 50px;"> </th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button class="action-icon">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="tableColumns; sticky: true"
        class="table-header"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: tableColumns"
        class="clickable-row"
        (click)="onEdit(row.id)"
      ></tr>
    </table>

  </ifc-app-scroll-container>

  <div [hidden]="data.dataSource.totalCount <= 10">
    <mat-paginator
      #paginator
      showFirstLastButtons
      [length]="data.dataSource.totalCount"
      [pageSizeOptions]="[10, 20, 50]"
      (page)="onFilter()"
    >
    </mat-paginator>
  </div>
</div>
